export enum Statut {
  open = 'A Faire',
  done = 'Terminée',
  inProgress = 'En cours',
  nonApplicable = 'Non-applicable'
}
